import { Component } from '@angular/core';
import * as fromMembers from '../../reducers/members.reducer';
import * as fromRoot from '@app/reducers';
import { Group } from '@app/shared/models/group';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { MembersActions } from '../../actions';
import { User } from '@app/shared/models/user';

@Component({
  selector: 'app-modal-detach-role',
  templateUrl: './modal-detach-role.component.html',
  styleUrls: ['./modal-detach-role.component.scss']
})
export class ModalDetachRoleComponent {

  roleToDetach: any;
  teamId: string;
  userId: string;
  memberDetails: User;

  detachRoleFromMemberPending$: Observable<boolean>;
  detachRoleFromMemberSuccess$: Observable<boolean>;
  detachRoleFromMemberError$: Observable<any>;

  submitted = false;
  subscriptions: Subscription[] = [];

  constructor(private store$: Store<fromRoot.State & fromMembers.State>, public ref: DialogRef) {
    this.roleToDetach = this.ref.data.roleToDetach;
    this.teamId = this.ref.data.teamId;
    this.memberDetails = this.ref.data.memberDetails;
    this.userId = this.ref.data.memberDetails.id;

    this.detachRoleFromMemberPending$ = this.store$.select(fromMembers.getDetachRoleFromMemberPending);
    this.detachRoleFromMemberSuccess$ = this.store$.select(fromMembers.getDetachRoleFromMemberSuccess);
    this.detachRoleFromMemberError$ = this.store$.select(fromMembers.getDetachRoleFromMemberError);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  close() {
    this.ref.close();
  }

  detachRoleFromMember() {
    this.submitted = true;
    this.store$.dispatch(MembersActions.detachRoleFromMember({ teamId: this.teamId, userId: this.userId, role: this.roleToDetach }));
    this.subscriptions.push(
      this.detachRoleFromMemberSuccess$.subscribe(res => {
        if (res) {
          this.store$.dispatch(MembersActions.loadMember({ teamId: this.teamId, userId: this.userId }));
          this.store$.dispatch(MembersActions.loadMemberRoles({ teamId: this.teamId, userId: this.userId }));
          this.close();
        }
      })
    );
  }
}
